import type { ComponentType, ReactNode } from 'react';
import React from 'react';
import { useIntl } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import { AdminManagementLayout } from '../admin-management-layout';
import { SettingsBreadcrumbs } from '../settings-breadcrumbs';
import messages from './messages';

const PROJECT_MAPPING_SUPPORT_DOC_URL =
    'https://support.atlassian.com/jira-service-management-cloud/docs/create-and-manage-help-centers';

export const HelpCenterManageProjects: ComponentType = () => {
    const { formatMessage } = useIntl();

    const helpCenterManageProjectsLink = (chunks: ReactNode) => (
        <a href={PROJECT_MAPPING_SUPPORT_DOC_URL} target="_blank" rel="noreferrer">
            {chunks}
        </a>
    );

    return (
        <AdminManagementLayout featureName="Helpcenter manage projects">
            <Stack space="space.300">
                <SettingsBreadcrumbs helpCenterName={'Test helpcenter'} />
                <Heading size="large">{formatMessage(messages.manageProjectsPageTitle)}</Heading>
                <Box>
                    <Text>
                        {formatMessage(messages.manageProjectsPageDescription, {
                            link: helpCenterManageProjectsLink,
                        })}
                    </Text>
                    <Box paddingBlockStart="space.200">
                        <Inline alignBlock="center">
                            <Text weight="medium" color="color.text.subtle">
                                {formatMessage(messages.manageProjectPageToggleForDefaultLinking)}
                            </Text>
                            <Toggle label={formatMessage(messages.defaultMappingToggleLabel)} />
                        </Inline>
                    </Box>
                </Box>
            </Stack>
        </AdminManagementLayout>
    );
};
